import Papa from 'papaparse';
import {
  commitSweepRowsToFirestore,
  extractSweepFieldsFromRow,
  normVal,
  type ExtractedSweepRow,
  type ImportResult,
} from './sweepImportShared';

export type { ImportResult };

export async function importSweepLocationsFromCsv(opts: {
  masterOwnerID: string;
  ownerID?: string;
  csvText: string;
  sweepFolderId?: string;
  sweepScheduledDate?: string;
}): Promise<ImportResult> {
  const masterOwnerID = normVal(opts.masterOwnerID);
  if (!masterOwnerID) throw new Error('masterOwnerID is required');
  const importBatchId = new Date().toISOString();

  const parsed = Papa.parse<Record<string, unknown>>(opts.csvText, { header: true, skipEmptyLines: true });
  if (parsed.errors?.length) {
    const first = parsed.errors[0];
    throw new Error(first?.message || 'Failed to parse CSV.');
  }

  const rows = Array.isArray(parsed.data) ? parsed.data : [];
  const extracted: ExtractedSweepRow[] = [];
  let skipped = 0;

  for (const r of rows) {
    const ex = extractSweepFieldsFromRow(r);
    if (!ex) {
      skipped++;
      continue;
    }
    extracted.push(ex);
  }

  const { imported } = await commitSweepRowsToFirestore({
    masterOwnerID,
    ownerID: opts.ownerID,
    importBatchId,
    rows: extracted,
    forcedSweepFolderId: opts.sweepFolderId,
    forcedSweepScheduledDate: opts.sweepScheduledDate,
  });

  return { imported, skipped, errors: [], importBatchId };
}
